import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import {FormattedMessage} from 'react-intl';

import MuiCheckbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

import FormContext from './FormContext';

class Checkbox extends React.Component {
    constructor(props) {
        super(props);

        this.getComponent = this.getComponent.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    getComponent({disabled, input, label, messageId, meta: {active, error, touched, warning}, onChange}) {
        return (
            <FormControl disabled={disabled} fullWidth>
                <FormControlLabel
                    control={
                        <MuiCheckbox
                            checked={input.value}
                            onChange={event => this.handleChange(event, input, onChange)}
                        />
                    }
                    label={messageId ? <FormattedMessage id={messageId}/> : label}
                />
                <FormHelperText error={!!error ? !!error : undefined}>
                    {do {
                        if (((active && input.value) || touched) && !!error) {
                            error;
                        } else if (active && !error && !!warning) {
                            warning;
                        }
                    }}
                </FormHelperText>
            </FormControl>
        );
    }

    handleChange(event, input, onChange) {
        event.persist();
        if (onChange) {
            onChange(event);
        }
        input.onChange(event);
    }

    render() {
        const {field, label, show, ...rest} = this.props;

        if (show !== undefined && !show) {
            return null;
        }

        return (
            <FormContext.Consumer>
                {context => {
                    return (
                        <span className="input checkbox">
                            <Field
                                component={this.getComponent}
                                field={field}
                                label={label}
                                name={field}
                                onKeyDown={context.handleKeyDown}
                                {...rest}
                            />
                        </span>
                    );
                }}
            </FormContext.Consumer>
        );
    }
}

Checkbox.propTypes = {
    field: PropTypes.string.isRequired,
    label: PropTypes.string,
    messageId: PropTypes.string,
    onChange: PropTypes.func,
    show: PropTypes.bool,
    type: PropTypes.string
};

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/common/form/Checkbox.js